// removed by extract-text-webpack-plugin
module.exports = {"main":"node_modules--brainhubeu-gatsby-docs-kit-src-components-main----main-module---main---25yzl"};


//////////////////
// WEBPACK FOOTER
// ./~/@brainhubeu/gatsby-docs-kit/src/components/main/main.module.scss
// module id = 248
// module chunks = 203135278815170